import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import StatusBadge from './StatusBadge';
import RoleBadge from './RoleBadge';

const UserMobileCard = ({ user, currentUserRole, onAction }) => {
  const [expanded, setExpanded] = useState(false);

  const canModify = currentUserRole === 'SUPER_ADMIN' || (currentUserRole === 'ADMIN' && user?.role !== 'SUPER_ADMIN');

  const actions = [];
  if (user?.status === 'ACTIVE') actions?.push({ key: 'suspend', label: 'Suspender', icon: 'UserX', danger: true });
  if (user?.status === 'SUSPENDED') actions?.push({ key: 'reactivate', label: 'Reactivar', icon: 'UserCheck', danger: false });
  if (user?.status === 'PENDING') {
    actions?.push({ key: 'activate', label: 'Activar', icon: 'CheckCircle', danger: false });
    actions?.push({ key: 'reject', label: 'Rechazar', icon: 'XCircle', danger: true });
  }
  actions?.push({ key: 'reset_password', label: 'Restablecer contraseña', icon: 'Key', danger: false });
  actions?.push({ key: 'view', label: 'Ver perfil', icon: 'Eye', danger: false });

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
      <div
        className="flex items-center gap-3 p-4 cursor-pointer"
        onClick={() => setExpanded(v => !v)}
      >
        <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center flex-shrink-0">
          <span className="text-sm font-bold text-teal-700 font-heading">
            {user?.name?.split(' ')?.map(n => n?.[0])?.slice(0, 2)?.join('')?.toUpperCase()}
          </span>
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-gray-800 font-heading truncate">{user?.name}</p>
          <p className="text-xs text-gray-500 font-caption truncate">{user?.email}</p>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <StatusBadge status={user?.status} />
          <Icon name={expanded ? 'ChevronUp' : 'ChevronDown'} size={16} color="#9CA3AF" />
        </div>
      </div>
      {expanded && (
        <div className="border-t border-gray-100 px-4 pb-4 pt-3 space-y-3">
          <div className="grid grid-cols-2 gap-3 text-xs font-caption">
            <div>
              <p className="text-gray-400 mb-0.5">Organización</p>
              <p className="text-gray-700 font-medium">{user?.organization}</p>
            </div>
            <div>
              <p className="text-gray-400 mb-0.5">NIT</p>
              <p className="text-gray-700 font-medium">{user?.nit}</p>
            </div>
            <div>
              <p className="text-gray-400 mb-0.5">Rol</p>
              <RoleBadge role={user?.role} />
            </div>
            <div>
              <p className="text-gray-400 mb-0.5">Último acceso</p>
              <p className="text-gray-700">{user?.lastLogin}</p>
            </div>
          </div>

          {canModify && (
            <div className="flex flex-wrap gap-2 pt-1">
              {actions?.map(action => (
                <button
                  key={action?.key}
                  onClick={() => onAction(user, action?.key)}
                  className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-caption border transition-colors ${
                    action?.danger
                      ? 'border-red-200 text-red-600 hover:bg-red-50' :'border-gray-200 text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  <Icon name={action?.icon} size={12} color={action?.danger ? '#DC2626' : 'currentColor'} />
                  {action?.label}
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default UserMobileCard;